// DEV 23 Oct (batch 6): static drawer images (trust strip, payment icons) carry data-aw-src so they are not fetched
// before first paint while the drawer is closed. Swapped in on open() and ~2s after window load.
function awLoadDrawerImages(root) {
  (root || document).querySelectorAll('img[data-aw-src]').forEach(function (img) {
    img.loading = 'eager'; // fetch now so the strip is ready when the drawer slides in
    img.src = img.getAttribute('data-aw-src');
    img.removeAttribute('data-aw-src');
  });
}
(function () {
  function later() { setTimeout(function () { awLoadDrawerImages(document.querySelector('cart-drawer')); }, 2000); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    awLoadDrawerImages(this);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ─────────────────────────────────────────────────────────────────────────────
   Custom event: 'ankhway:open-cart'
   Dispatching this event will:
     1. Fetch fresh cart drawer + icon bubble HTML via Section Rendering API
     2. Re-render both sections in the DOM
     3. Open the cart drawer

   Usage (e.g. from Replo button "Custom JS" after Add to Cart):
     document.dispatchEvent(new CustomEvent('ankhway:open-cart'));
───────────────────────────────────────────────────────────────────────────── */
document.addEventListener('ankhway:open-cart', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)
    .then((res) => res.json())
    .then((sections) => {
      /* ── Re-render .drawer__inner only (mirror CartDrawerItems.getSectionsToRender) ── */
      const drawerInnerEl = document.querySelector('#CartDrawer .drawer__inner');
      if (drawerInnerEl && sections['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newInner = parsed.querySelector('.drawer__inner');
        if (newInner) drawerInnerEl.innerHTML = newInner.innerHTML;
      }

      /* ── Re-render cart icon bubble ── */
      const iconBubble = document.getElementById('cart-icon-bubble');
      if (iconBubble && sections['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = parsed.querySelector('.shopify-section');
        if (newBubble) iconBubble.innerHTML = newBubble.innerHTML;
      }

      /* ── Re-bind overlay close after DOM replacement ── */
      const overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => cartDrawer.close());

      /* ── Update is-empty + open ── */
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          cartDrawer.classList.toggle('is-empty', cart.item_count === 0);
          cartDrawer.open();
        });
    })
    .catch((err) => {
      console.error('[ankhway:open-cart] Failed to refresh cart:', err);
      cartDrawer.open();
    });
});

